import { demographicConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { demographicDataLoading: true, data: '', error: false };

export function addDemographicData(state = initialState, action) {

    switch (action.type) {
        case demographicConstants.REQUEST_ADD_DEMOGRAPHIC_DATA:
            return {
                demographicDataLoading: true,
                data: '',
                error: false
            };
        case demographicConstants.RECIEVE_ADD_DEMOGRAPHIC_DATA:
            swal({
                text: 'Successfully Added',
                type: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            return {
                demographicDataLoading: false,
                data: action.demographicData,
                error: false,
            };
        case demographicConstants.ERROR_ADD_DEMOGRAPHIC_DATA:
            swal({
                text: action.error.response.data.demographic_name,
                type: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            return {
                demographicDataLoading: false,
                data: action.error,
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/demographicData/addDemographicData.reducer.js